import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=2d417443"
import script from "./Feed.vue?vue&type=script&lang=ts"
export * from "./Feed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports